import React, { useState, useEffect } from 'react';
import { PlayCircle, PauseCircle } from 'react-feather';
import store from '../../../redux';

const Player = ({ audioName, stopAllAudio }) => {
  const [audioUrl, setAudioUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const userToken = store.getState().auth.login.data.access_token;

  const downloadAudio = () => {
    setLoading(true);
    const url = process.env.REACT_APP_API_BASE_URL + '/downloadwav?wav_name=' + audioName;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        setAudioUrl(url);
        setLoading(false);
      });
  };

  const [isPlaying, setIsPlaying] = useState(false);

  const audioEl = React.useRef(null);

  const toggle = () => {
    downloadAudio()
    audioEl.current.oncanplay = () => {
      setIsPlaying(!isPlaying);
      setLoading(false);
    };

    audioEl.current.onerror = () => {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (isPlaying) {
      audioEl.current.play();
    } else {
      audioEl.current.pause();
    }
    audioEl.current.onended = () => {
      setIsPlaying(false);
    };

    audioEl.current.onpause = () => {
      setIsPlaying(false);
    };
  }, [isPlaying]);

  return (
    <div className="cursor-pointer">
      <audio ref={audioEl} src={audioUrl} />
      <div onClick={toggle}>
        {
          loading ? (
            <div className="spinner-border spinner-border-sm" role="status">
            </div>
          ) : isPlaying ? <PauseCircle size={20} /> : <PlayCircle size={20} onClick={stopAllAudio} />

        }
      </div>
    </div>
  );
};

export default Player;
